import './maintenance.scss';

import * as React from 'react';
import Dialog from 'react-bootstrap-dialog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { PlantModel } from '../../model/PlantModel';
import { parseJwt } from '../../services/loginService';
import { deletePlant, getPlantDetails } from '../../services/plantService';
import { isAdmin } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ErrorPage } from '../reusableComponents/ErrorPage';
import { Loader } from '../reusableComponents/Loader';
import { inspectionType } from '../../constants/generals';

export interface IDetailsPageProps {
    instance: PlantModel;
    history: IHistory;
    id: string;
    plantId: string;
    Access_Level: string;
    userId: string;
}

export class DetailsPageImpl extends React.PureComponent<IDetailsPageProps, {}> {
    constructor(props: IDetailsPageProps) {
        super(props);
    }

    promise = async () => {
        //if (!this.props.instance) {
            await getPlantDetails(this.props.plantId);
        //}
    }

    componentDidMount() {
        Dialog.setOptions({
            defaultOkLabel: 'Yes',
            defaultCancelLabel: 'No',
        });
    }

    dialog: Dialog = null;

    refs: {

    };

    handlePlantDelete = () => {
        this.dialog.show({
            body: `Are you sure you want to delete plant ${this.props.instance.props.Plant_Name}?`,
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => deletePlant(this.props.instance.props.id, this.props.history))
            ]
        });
    }

    renderContent = () => {
        if (!this.props.instance) {
            return <Loader type="async" />;
        }
        return <div className="details-page-wrapper" >
            <Dialog className="confirmation-modal" ref={(el) => { this.dialog = el; }} />
            <div className="details-left-section" >
                <DisplayDetails label="Plant ID" value={this.props.instance.props.PlantId} />
                <DisplayDetails label="Region" value={this.props.instance.props.Plant_Region} />
                <DisplayDetails label="Name" value={this.props.instance.props.Plant_Name} />
                <DisplayDetails label="Street" value={this.props.instance.props.Street} />
                <DisplayDetails label="Address City" value={this.props.instance.props.City} />
                <DisplayDetails label="State" value={this.props.instance.props.State} />
                <DisplayDetails label="Zip Code" value={this.props.instance.props.Zip} />
                <DisplayDetails label="Country" value={this.props.instance.props.Country} />
            </div>
            <div className="details-right-section" >
                <div className="form-type-boxes" >
                    <div className="details-label" >
                        Form Type:
                </div>
                    <Card isTrue={this.props.instance.props.Inspections.DailyForm}>{inspectionType('DailyForm')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.PlantPreventive}>{inspectionType('Daily Plant Preventive')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.MonthlySPCC}>{inspectionType('MonthlySPCC')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.MonthlySpillLogs}>{inspectionType('MonthlySpillLogs')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.MonthlySW}>{inspectionType('MonthlySW')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.MonthlyUSTRect}>{inspectionType('MonthlyUSTRect')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.MonthlyUSTSpill}>{inspectionType('MonthlyUSTSpill')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.QTRVisual}>{inspectionType('QTRVisual')}</Card>
                    <Card isTrue={this.props.instance.props.Inspections.ShopInspection}>{inspectionType('ShopInspection')}</Card>
                </div>
                <div className="form-type-boxes" >
                    <div className="details-label" >
                        Outfall:
                </div>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall1}>Outfall 1</Card>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall2}>Outfall 2</Card>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall3}>Outfall 3</Card>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall4}>Outfall 4</Card>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall5}>Outfall 5</Card>
                    <Card isTrue={this.props.instance.props.Outfalls.Outfall6}>Outfall 6</Card>

                </div>
                <div className="buttons-container" >
                    <div
                        onClick={() => this.props.history.push(`/maintenance/update/${this.props.instance.props.id}`)}
                        title={`Click to Edit the Details of Plant ${this.props.instance.props.PlantId}`}
                        className="edit-details-button" >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                    </div>
                    {isAdmin(this.props.Access_Level) ?
                        <div
                            onClick={this.handlePlantDelete}
                            title={`Click to Delete the Details of Plant ${this.props.instance.props.PlantId}`}
                            className="delete-details-button" >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </div>
                        : ''}
                </div>
            </div>
        </div >;
    }

    render() {
        return (
            <BasePage pageTitle="Plant Information"  >
                <Async
                    identifier="PlantDetailsPage"
                    promise={this.promise}
                    loader={<Loader type="async" />}
                    error={<ErrorPage />}
                    content={this.renderContent()}
                />
            </BasePage>
        );
    }
}
export function mapStateToProps(state, ownProps) {
    const instance = PlantModel.get(ownProps.match.params.id);
    const plantId = ownProps.match.params.plantId;
    const userId = state.login.get('UniqueId');
    const Access_Level = parseJwt(state.login.get('token')).Access_Level;
    return {
        userId, instance, plantId, id: ownProps.match.params.id, Access_Level
    };
}
export const DetailsPage = withRouter(connect<{}, {}, IDetailsPageProps>(mapStateToProps)(DetailsPageImpl as any));

const DisplayDetails = ({ label, value }) => {
    return <div className="details-row" >
        <Label labelText={label} />
        <Value value={value} />
    </div>;
};

const Label = ({ labelText }) => {
    return <div className="details-label" >
        {labelText}:
    </div>;
};

const Value = ({ value }) => {
    return <div className="details-value">
        {value}
    </div>;
};

const Card = ({ isTrue, children }) => {
    return <div className={isTrue ? 'green-card' : 'gray-card'} >
        {children || 'NA'}
        <i className="fa fa-check-circle-o" aria-hidden="true"></i>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Maintenance/DetailsPage.tsx